import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "./Imagem/logo.jpeg";

const services = [
  {
    id: "lavagem",
    name: "Lavagem",
    fullName: "Lavagem Completa",
    icon: "💧",
    desc: "Externa + interna · Secagem · Aspiração",
    price: "A partir R$60",
    accent: "#74c0fc",
    bg: "linear-gradient(135deg, #0d1b2a 0%, #1a3a5c 100%)",
    border: "#1e4a78",
    iconBg: "rgba(77,171,247,0.15)",
    bar: "linear-gradient(90deg, transparent, #4dabf7, transparent)",
  },
  {
    id: "lavagem-detalhada",
    name: "Detalhada",
    fullName: "Lavagem Detalhada",
    icon: "🔬",
    desc: "Higienização total · Bancos · Tapetes",
    price: "Consulte valor",
    accent: "#c77dff",
    bg: "linear-gradient(135deg, #1a0a2e 0%, #3d1a6b 100%)",
    border: "#5a2da0",
    iconBg: "rgba(180,122,255,0.15)",
    bar: "linear-gradient(90deg, transparent, #b47aff, transparent)",
  },
  {
    id: "polimento",
    name: "Polimento",
    fullName: "Polimento",
    icon: "✨",
    desc: "Remove riscos · Brilho espelhado",
    price: "Consulte valor",
    accent: "#ffd43b",
    bg: "linear-gradient(135deg, #1a1000 0%, #3d2a00 100%)",
    border: "#7a5500",
    iconBg: "rgba(255,212,59,0.15)",
    bar: "linear-gradient(90deg, transparent, #ffd43b, transparent)",
  },
  {
    id: "restauracao",
    name: "Restauração de farol",
    fullName: "Restauração Completa de Faróis",
    icon: "💡",
    desc: "Remove amarelado · Recupera brilho e transparência",
    price: "Consulte valor",
    accent: "#ffd43b",
    bg: "linear-gradient(135deg, #2b2100 0%, #4d3b00 100%)",
    border: "#8f6b00",
    iconBg: "rgba(255,212,59,0.15)",
    bar: "linear-gradient(90deg, transparent, #ffd43b, transparent)",
  },
  {
    id: "pintura",
    name: "Pintura",
    fullName: "Pintura & Funilaria",
    icon: "🎨",
    desc: "Correção de cor · Funilaria · Repintura",
    price: "Consulte valor",
    accent: "#ff8787",
    bg: "linear-gradient(135deg, #1f0a08 0%, #4a1510 100%)",
    border: "#8a2218",
    iconBg: "rgba(255,107,107,0.15)",
    bar: "linear-gradient(90deg, transparent, #ff6b6b, transparent)",
  },
];

export default function PaginaServicos() {
  const canvasRef = useRef(null);
  const navigate = useNavigate();

  const [activeShimmer, setActiveShimmer] = useState(0);

  const handleClick = (serviceId) => {
    navigate(`/agendamento/${serviceId}`);
  };

  // shimmer automático
  useEffect(() => {
    const id = setInterval(() => {
      setActiveShimmer((prev) => (prev + 1) % services.length);
    }, 2200);

    return () => clearInterval(id);
  }, []);

  // canvas animado
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    let animId;

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    resize();
    window.addEventListener("resize", resize);

    const particles = Array.from({ length: 40 }, () => ({
      x: Math.random() * window.innerWidth,
      y: Math.random() * window.innerHeight,
      r: Math.random() * 1.5 + 0.3,
      vx: (Math.random() - 0.5) * 0.3,
      vy: -(Math.random() * 0.4 + 0.1),
      life: Math.random(),
      maxLife: Math.random() * 0.5 + 0.3,
      color: Math.random() > 0.5 ? "#e8c84a" : "#ff6b35",
    }));

    const smokes = [];

    const smokeId = setInterval(() => {
      smokes.push({
        x: Math.random() * canvas.width * 0.6 + canvas.width * 0.2,
        y: canvas.height,
        r: 8 + Math.random() * 10,
        vx: (Math.random() - 0.5) * 0.6,
        vy: -(Math.random() * 0.8 + 0.4),
        alpha: 0.12 + Math.random() * 0.08,
        grow: 0.8 + Math.random() * 0.6,
      });
    }, 280);

    const loop = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const grad = ctx.createLinearGradient(0, 0, 0, canvas.height);
      grad.addColorStop(0, "#0a0a0f");
      grad.addColorStop(1, "#0d0d1a");

      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // grid
      ctx.strokeStyle = "rgba(232,200,74,0.04)";
      ctx.lineWidth = 1;

      for (let x = 0; x < canvas.width; x += 40) {
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x, canvas.height);
        ctx.stroke();
      }

      for (let y = 0; y < canvas.height; y += 40) {
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(canvas.width, y);
        ctx.stroke();
      }

      // smoke
      for (let i = smokes.length - 1; i >= 0; i--) {
        const s = smokes[i];

        s.x += s.vx;
        s.y += s.vy;
        s.r += s.grow * 0.15;
        s.alpha -= 0.0015;

        if (s.alpha <= 0) {
          smokes.splice(i, 1);
          continue;
        }

        const sg = ctx.createRadialGradient(
          s.x,
          s.y,
          0,
          s.x,
          s.y,
          s.r
        );

        sg.addColorStop(0, `rgba(180,180,200,${s.alpha})`);
        sg.addColorStop(1, `rgba(100,100,120,0)`);

        ctx.fillStyle = sg;
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fill();
      }

      // particles
      particles.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        p.life -= 0.003;

        if (p.life <= 0 || p.y < -10) {
          p.x = Math.random() * canvas.width;
          p.y = canvas.height + 10;
          p.life = p.maxLife;
        }

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = p.color;
        ctx.fill();
      });

      animId = requestAnimationFrame(loop);
    };

    loop();

    return () => {
      cancelAnimationFrame(animId);
      clearInterval(smokeId);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#0a0a0f",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Canvas fundo */}
      <canvas
        ref={canvasRef}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 0,
          pointerEvents: "none",
        }}
      />

      {/* Conteúdo */}
      <div
        style={{
          position: "relative",
          zIndex: 1,
          maxWidth: 480,
          margin: "0 auto",
          paddingBottom: 40,
        }}
      >
        {/* Header */}
        <div style={{ textAlign: "center", padding: "32px 20px 20px" }}>
          <div
            style={{
              width: 320,
              height: 180,
              margin: "0 auto 16px",
              borderRadius: "10%",
              overflow: "hidden",
            }}
          >
            <img
              src={logo}
              alt="Area 51"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </div>

          <h1 style={{ color: "#e8c84a" }}>AREA 51</h1>

          <p style={{ color: "#888" }}>
            Detalhamento Automotivo Premium
          </p>
        </div>

        {/* Serviços */}
        <div style={{ padding: "0 16px" }}>
          {services.map((svc, idx) => (
            <div
              key={svc.id}
              onClick={() => handleClick(svc.id)}
              style={{
                background: svc.bg,
                border: `1px solid ${svc.border}`,
                borderRadius: 16,
                padding: 20,
                marginBottom: 12,
                cursor: "pointer",
                transform:
                  idx === activeShimmer ? "scale(1.02)" : "scale(1)",
                transition: "0.3s",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                }}
              >
                <div style={{ fontSize: 28 }}>{svc.icon}</div>

                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      color: svc.accent,
                      fontSize: 22,
                      fontWeight: "bold",
                    }}
                  >
                    {svc.name}
                  </div>

                  <div
                    style={{
                      color: "#aaa",
                      fontSize: 13,
                    }}
                  >
                    {svc.desc}
                  </div>
                </div>

                <div style={{ color: svc.accent }}>
                  {svc.price}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div style={{ textAlign: "center", padding: "24px 20px" }}>
          <div style={{ color: "#555" }}>
            Segunda a Sábado · 8h às 18h
          </div>

          <a
            href="https://wa.me/555180598568"
            target="_blank"
            rel="noreferrer"
            style={{
              display: "inline-block",
              marginTop: 12,
              padding: "10px 20px",
              background: "rgba(37,211,102,0.1)",
              border: "1px solid rgba(37,211,102,0.25)",
              borderRadius: 50,
              color: "#25d366",
              textDecoration: "none",
            }}
          >
            💬 Dúvidas? WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
}